/* global angular, Datamap, chroma, _, d3, jQuery */

var ngModule = angular.module('trends');
var $ = jQuery;

ngModule.directive('heatmapWidget', ['BrowserDetector', function (BrowserDetector) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope) {
            scope.isMapShowable = function () {
                var browser = BrowserDetector.getBrowserInfo();
                return !(browser.name === 'MSIE' && browser.version === '8');
            };
        }
    };
}]);

ngModule.directive('heatmap', ['Api', 'QuerySerializer', '$state', '$timeout', '$location',
    function (Api, QuerySerializer, $state, $timeout, $location) {

    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {
            var mapData, map, selectedRegion, placesNotCovered, carouselOpen = false;

            // Zoom co-efficients. Note that these are region HVT IDs, not region IDs.
            var regions = {
                51: { x: 505, y: 255, scale: 1.8 }, // Asia Pacific
                52: { x: 330, y: 200, scale: 1.7 }, // EMEA
                53: { x: 140, y: 120, scale: 2 },   // North America
                54: { x: 175, y: 290, scale: 2 }    // Latin America
            };

            // Short region names to show for region filters on mobile
            scope.shortRegionNames = {
                'Asia Pacific': 'APAC',
                'Europe, Middle East & Africa': 'EMEA',
                'Latin America': 'LAR',
                'North America': 'NA'
            };

            var regionCodes;
            scope.regionsReady = false;
            Api.heatmap.get({ 'mode': 'region' }).then(function (response) {
                regionCodes = response.plain();
                scope.regionsReady = true;
            });

            /* Time filters to display above the heatmap. Has no 'all time' unlike search filters */
            scope.timeFilters = [
                { description: 'Last year',  value: '365' },
                { description: 'Last month', value: '30' },
            ];

            /* Go to the search page and show filtered observations */
            scope.viewObservations = function () {
                var serializer = new QuerySerializer({
                    filters: { type: 'object', required: false },
                    focus:   { type: 'string', required: false }
                });

                var data = { filters: {} };
                data.focus = 'observation';
                data.filters.time = parseInt(scope.selectedTime) || null;

                // HVT filter dropdown is only enabled in trend mode
                if (attrs.heatmapMode === 'trend') {
                    data.filters.related_trend = [ parseInt(attrs.heatmapId) ];

                    if (scope.filter.id) {
                        var key = scope.filter.type, id = scope.filter.id;
                        data.filters[key] = [ key === 'region' ? regionCodes[id] : id ];
                        // Update the path without reloading solely for redirecting to clients
                        $location.search('hvt_id', id);
                    }
                } else {
                    var key = attrs.heatmapKey;
                    var id = parseInt(attrs.heatmapId);

                    data.filters[key] = [ key === 'region' ? regionCodes[id] : id ];
                }

                if (selectedRegion) {
                    var regionCode  = regionCodes[selectedRegion];
                    data.filters.region = [ regionCode ];
                    // Update the path without reloading solely for redirecting to clients
                    $location.search('region_code', regionCode);
                }

                $state.go('search', serializer.generate(data));
            };

            /* Access API to get data to visualise via the heatmap */
            scope.refreshData = function () {
                // Carousel's observation results will no longer be relevant so hide it
                if (carouselOpen) {
                    scope.carouselReady = false;
                    $timeout(function() {
                        jQuery('#carousel-toggle').click();
                    });
                    carouselOpen = false;
                }

                scope.filter = {};

                if (scope.selectedFilter) {
                    var filter = scope.selectedFilter.split('-');

                    scope.filter.type = filter[0];
                    scope.filter.id = parseInt(filter[1]);
                }

                if (attrs.heatmapKey === 'region') {
                    scope.filter.region = attrs.heatmapId;
                } else {
                    scope.filter.region = scope.selectedRegion || null;
                }

                var hvt_id = scope.filter ? scope.filter.id : null;

                scope.dataReady = false;

                if (!placesNotCovered) {
                    scope.coverageReady = false;

                    Api.heatmap.get({
                        'mode': 'coverage'
                    }).then(function (response) {
                        placesNotCovered = response.places;
                        scope.coverageReady = true;
                    });
                }

                Api.heatmap.get({
                    'id': attrs.heatmapId,
                    'mode': attrs.heatmapMode,
                    'hvt_id': hvt_id,
                    'region_hvt_id' : scope.filter.region,
                    'days_from_today': scope.selectedTime
                }).then(function (response) {
                    mapData = response;
                    scope.dataReady = true;
                });
            };

            /* Get the IDs of the HVTs which have observations tagged for this trend */
            var getFilters = function () {
                scope.filtersReady = false;
                var region_hvt_id = scope.selectedRegion || null;

                Api.heatmap.get({
                    id: attrs.heatmapId, mode: 'filter', region_hvt_id: region_hvt_id,
                    days_from_today: scope.selectedTime
                }).then(function (response) {
                    scope.filterIds = response;
                    scope.filtersReady = true;
                });
            };

            /* Only allow the user to filter heatmap data by HVTs that actually have observations tagged */
            scope.hvtFilter = function (filter) {
                if(scope.filterIds) {
                    return _.contains(scope.filterIds.filters, filter.hvt_id);
                }
            };

            /* a borderline hack to allow us to change the size of the heatmap
            when adding it to a presentation. */
            scope.redraw = function(width, height) {
                var container = element.find('#heatmap-container');
                var width = container.width();
                var height = container.height();
                displayMapFixed(width, height);
            };

            var buildMap = function() {
                // Create colour scale
                var colourScale = chroma.scale(['#BEE6F0', '#1DA8DF']);

                // Find maximum data value to normalise data values between 0-1 for regions
                var max = _.max(mapData, function (x) { if (x) { return x.observations; } }).observations;

                jQuery('#heatmap-container').find('svg').remove();

                map = new Datamap({
                    element: element.find('#heatmap-container')[0],
                    data: mapData,
                    projection: 'mercator',
                    geographyConfig: {
                        popupTemplate: function(geography) {
                            var name = geography.properties.name;
                            if(geography.id && geography.id === 'CHN' || geography.id === 'TWN') {
                                name = 'China & Taiwan';
                            }
                            return '<div class="hoverinfo"><strong>' + name + '</strong></div>';
                        },
                        highlightFillColor: '#FFE512',
                        highlightBorderColor: '#FFFFFF',
                        highlightOnHover: function(data, options, customObject) {
                            // Only continue if this is either of the two locations
                            var this_iso = customObject && customObject.geoData && customObject.geoData.id;
                            if(!this_iso || (this_iso !== 'CHN' && this_iso !== 'TWN')) { return !_.isEmpty(data); }

                            // Only continue if at least one location has data
                            var other_iso = ( this_iso === 'CHN' )? 'TWN' : 'CHN';
                            var $this = d3.select($('.datamaps-subunit.' + other_iso)[0]);
                            var $data = customObject.dataMap.options.data[other_iso] || {};
                            if(_.isEmpty(data) && _.isEmpty($data)) { return false; }

                            if(customObject.mouseover) {
                                // Copied from datamaps.js
                                var previousAttributes = {
                                    'fill':  $this.style('fill'),
                                    'stroke': $this.style('stroke'),
                                    'stroke-width': $this.style('stroke-width'),
                                    'fill-opacity': $this.style('fill-opacity')
                                };

                                $this
                                    .style('fill', options.highlightFillColor)
                                    .style('stroke', options.highlightBorderColor)
                                    .style('stroke-width', options.highlightBorderWidth)
                                    .style('fill-opacity', options.highlightFillOpacity)
                                    .attr('data-previousAttributes', JSON.stringify(previousAttributes));

                                //as per discussion on https://github.com/markmarkoh/datamaps/issues/19
                                if ( ! /((MSIE)|(Trident))/.test ) {
                                    this.parentNode.appendChild(this);
                                }
                            }
                            else if (customObject.mouseout) {
                                // Copied from datamaps.js
                                //reapply previous attributes
                                var previousAttributes = JSON.parse( $this.attr('data-previousAttributes') );
                                for ( var attr in previousAttributes ) {
                                    $this.style(attr, previousAttributes[attr]);
                                }
                                $this.on('mousemove', null);
                            }
                            // Force hightlight on this location
                            // If we got this far, it means we want both locations higlighted
                            return true;
                        },
                        popupOnHover: function (data, customObject) {
                            // Only continue if this is either of the two locations
                            var this_iso = customObject && customObject.geoData && customObject.geoData.id;
                            if(!this_iso || (this_iso !== 'CHN' && this_iso !== 'TWN')) { return !_.isEmpty(data); }

                            // Only continue if at least one location has data
                            var other_iso = ( this_iso === 'CHN' )? 'TWN' : 'CHN';
                            var $data = customObject.dataMap.options.data[other_iso] || {};
                            if(_.isEmpty(data) && _.isEmpty($data)) { return false; }

                            // If we got this far, it means we want the popup
                            return true;
                        }
                    },
                    fills: {
                        defaultFill: function (geography, data) {
                            if (data) {
                                if (data.heat_level !== undefined){
                                   // divide by 4 to scale heat_value from 1 to 4
                                   return colourScale(data.heat_level/4).toString();
                                }
                                else{
                                    return colourScale(data.observations / max).toString();
                                }
                            } else {
                                if (_.contains(placesNotCovered, geography.id)) {
                                    return '#E9F3FB';
                                } else {
                                    return '#DEECF7';
                                }
                            }
                        }
                    },
                    done: function() {
                        // When a country with data is clicked, show relevant observation carousel
                        /* TODO create one loop for the 2 following things */
                        $('.datamaps-subunits path').each(function(index) {
                            var country = $('.datamaps-subunits path').eq(index);
                            var countryDefaultFill = country.css('fill');
                            if (country.attr('data-info')) {
                                country.attr('tabindex', 0);
                            }
                            else {
                                country.attr('tabindex', -1);
                            }
                            country.on('focus', function() {
                                country.css('fill', 'rgb(255, 229, 18)');
                            });
                            country.on('focusout', function() {
                                country.css('fill', countryDefaultFill);
                            });
                        });
                        var triggerCarousel = function(geography) {
                            var data = JSON.parse(d3.select(this).attr('data-info'));

                            if (data) {
                                // Force the carousel ng-include to reload by disabling it first
                                scope.$apply(function() {
                                    scope.carouselReady = false;
                                });

                                scope.$apply(function() {
                                    scope.selectedPlace = scope.selectedPlace !== geography ? geography : null;
                                    scope.carouselReady = scope.selectedPlace ? true : false;
                                });

                                /* Expand/collapse the carousel container as necessary (hacky, but it seems there
                                   is no way of programmatically expanding/collapsing an AngularStrap Collapse) */
                                if (scope.carouselReady && !carouselOpen) {
                                    // expand
                                    jQuery('#carousel-toggle').click();
                                    jQuery('.heatmap-carousel').focus();
                                    carouselOpen = true;
                                } else if (!scope.carouselReady) {
                                    // collapse
                                    jQuery('#carousel-toggle').click();
                                    carouselOpen = false;
                                }

                                if (carouselOpen) {
                                    // ensure carousel is visible if it isn't already
                                    var height = jQuery('#carousel-container').offset().top + 325 -
                                        jQuery(window).height();

                                    if (jQuery('body,html').scrollTop() < height) {
                                        jQuery('body,html').animate({ scrollTop: height }, 500);
                                    }
                                }
                            }
                        };
                        d3.selectAll('path').on('click', triggerCarousel);
                        /* IE and Firefox do not support tabindex in SVG. We still add
                        the which/keyCode check in case one day they start doing so */
                        d3.selectAll('path').on('keypress', function (event) {
                            if (event.which === 13 || event.keyCode === 13) {
                                event.preventDefault();
                                triggerCarousel();
                            }
                        });
                    }
                });
            };

            /* Draw the heatmap with scaling based on the users screen size */
            var displayMap = function () {
                // Resize the parent div to fit the heatmap without too much overflow or empty space
                // (default scaling is 600x400 so 600x350 will cut 50px off the map to save space)
                var container = element.find('#heatmap-container');
                container.removeAttr('style');

                var width = container[0].clientWidth;
                container.height((350/600 * width) + 'px');
                buildMap();
                if (scope.filter.region) {
                    zoom(scope.filter.region, true);
                }
            };

            /* draw the heatmap with a specified width and height */
            var displayMapFixed = function(width, height) {
                var container = element.find('#heatmap-container');
                container.width(width);
                container.height(height);
                buildMap();
                if (scope.filter.region) {
                    zoom(scope.filter.region, false);
                }
            };

            /* Zooms into the heatmap into the specified region */
            var zoom = function (regionId, transition) {
                var x, y, scale, duration;

                var width = element.find('#heatmap-container').width();
                var height = parseInt(map.svg.style('height'));

                if (attrs.heatmapKey === 'region' || (scope.mapReady && scope.filter.region !== 0)) {
                    duration = 0;
                } else {
                    duration = 750;
                }

                if (regionId) {
                    var region = regions[regionId];

                    var windowScale = width / 600;
                    x = windowScale * region.x;
                    y = windowScale * region.y;
                    scale = region.scale;
                    selectedRegion = regionId;
                } else {
                    x = 0;
                    y = 0;
                    scale = 1;
                    selectedRegion = null;
                }

                if (x === 0 && y === 0) {
                    x = width/2;
                    y = height/2;
                }

                if (transition) {
                    d3.select('g').transition()
                    .duration(duration)
                    .attr(
                        'transform',
                        'translate(' + width/2 + ',' + height/2 + ')' +
                        'scale(' + scale + ')' +
                        'translate(' + -x + ',' + -y + ')'
                    );
                }
                else {
                    d3.select('g').attr(
                        'transform',
                        'translate(' + width/2 + ',' + height/2 + ')' +
                        'scale(' + scale + ')' +
                        'translate(' + -x + ',' + -y + ')'
                    );
                }
            };

            // If the time or region filters are changed, reload the HVT filter list
            scope.$watch('selectedTime', getFilters);
            scope.$watch('selectedRegion', getFilters);

            /* Once the required data has finished loading, we can draw the heatmap */
            scope.$watch(function() {
                return scope.coverageReady && scope.dataReady;
            }, function () {
                if (scope.coverageReady && scope.dataReady) {
                    displayMap();
                    scope.mapReady = true;
                } else {
                    scope.mapReady = false;
                }
            });

            /* On region HVT pages, zoom into that region as soon as the map is ready */
            scope.$watch('mapReady', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    var regionId;

                    if (attrs.heatmapKey === 'region') {
                        regionId = parseInt(attrs.heatmapId);
                    } else if (scope.filter.region !== 0) {
                        regionId = scope.filter.region;
                    }
                    zoom(regionId, true);
                }
            });

            /* Remove the window resize event when navigating to another page */
            scope.$on('$stateChangeStart', function() {
                $(window).off('resize.heatmap');
            });

            /* Once the page has loaded... */

            // Add attribute to the scope so it is accessible by the observation carousel
            scope.hvtId = attrs.heatmapMode === 'hvt' ? attrs.heatmapId : null;

            getFilters();

            scope.refreshData();

            /* Re-draw the heatmap to fit the screen when the window resizes */
            $(window).on('resize.heatmap', function() {
                displayMap();
            });
        }
    };
}]);

